export const LOADER_TYPES = {
    BOOK_A_MEETING: "BOOK_A_MEETING",
    DEFAULT: "DEFAULT"
};
